import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import GameComponent from './components/AuraEater';

const AuraEater = (props) => {
    return (
        <main className="relative bg-black min-h-screen w-full flex flex-col items-center justify-center text-gray-200 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-black to-indigo-900/50 z-0" />
            <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-30 z-0" />
            <div className="relative z-10 flex flex-col items-center justify-center w-full h-full p-4">
                <GameComponent {...props} />
            </div>
        </main>
    );
};

export default AuraEater;
